// Content load handler
// - Fügt Klassen bei DOMContentLoaded / load hinzu
// - Lazy-load für Elemente mit `data-src`
// - Entfernt optionalen Preloader (#preloader)

import { lazyLoadImages, captureVideoSources, setupLogoVideo } from './inc/lazyLoad';
import { initMobileMenu } from './inc/mobileMenu';
import { initScrollAnimations } from './inc/scrollAnimations';
import { initScrollMorph } from './inc/scrollMorph';
import { initScrollHeading } from './inc/scrollHeading';

function removePreloader(): void {
	const pre = document.getElementById('preloader');
	if (pre && pre.parentNode) pre.parentNode.removeChild(pre);
}

function initHeroAnimation(): void {
	const teaser = document.getElementById('teaser');
	if (teaser) {
		teaser.classList.add('animate-in');
	}
}

function onDOMContentLoaded(): void {
	document.documentElement.classList.add('dom-ready');
	document.body.classList.add('dom-ready');
	
	// LazyLoad zuerst
	lazyLoadImages(document);
	
	// Video-Pfade aus HTML auslesen und speichern
	captureVideoSources();
	
	initMobileMenu();
}

function onWindowLoad(): void {
	document.documentElement.classList.add('loaded');
	document.body.classList.add('loaded');
	removePreloader();
	
	// Hero-Animation sofort triggern
	initHeroAnimation();
	
	// Animationen erst NACH Preloader-Entfernung
	initScrollAnimations();
	
	// Scroll-Morph initialisieren
	initScrollMorph();
	
	// Scroll-Heading initialisieren
	initScrollHeading();

	// Video Setup mit richtiger Variante
	setupLogoVideo();
}

export function initContentLoadHandler(): void {
	if (document.readyState === 'complete') {
		onDOMContentLoaded();
		onWindowLoad();
		return;
	}

	if (document.readyState === 'interactive') {
		onDOMContentLoaded();
		window.addEventListener('load', onWindowLoad, { once: true });
		return;
	}

	window.addEventListener('DOMContentLoaded', onDOMContentLoaded, { once: true });
	window.addEventListener('load', onWindowLoad, { once: true });
}

// Auto-init when module is imported
initContentLoadHandler();

